import { TimeSeriesChartDataItem } from './TimeSeriesChartData';

export function calculateTimeDomain(
    data: TimeSeriesChartDataItem[]
): [number, number] {
    if (data.length === 0) {
        return [0, 1];
    }

    const startDate = new Date(data[0].time);
    const startTime = startDate.getTime();

    const endTime = data[data.length - 1].time;

    return [startTime, endTime];
}

const MINUTES_IN_MS = 60 * 1000;
export const convertToMilliseconds: (d: number) => number = (d) =>
    d * MINUTES_IN_MS;
